import {
  getCmsPackageList,
  getPackageAmountList,
} from 'aster-foundation/core/teleconsultant/healthPackages/redux/actions';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SectionBox from '../../../Common/Component/SectionBox/SectionBox';
import SlickSlider from '../../../Common/Component/SlickSlider/SlickSlider';
import { PACKAGE_URL, TELECONSULT_ROUTE } from '../../../Common/Utility/constants';
import Package from '../PackageCard/Package';
import { PackageCarouselStyled } from './PackageCarouselStyled';
import { PAGE_NAME } from '@common/Constants/analytics';
import { sendViewAllLinkEvent, packageViewitemListEvent } from '../PackageAnalytics/packageAnalytics';
import withAnalytics from '@common/Component/Hoc/WithAnalytics';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const responsive = [
  {
    breakpoint: 980,
    settings: {
      slidesToShow: 5,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 3,
    },
  },
  {
    breakpoint: 480,
    settings: {
      variableWidth: true,
      slidesToShow: 1,
      infinite: true,
    },
  },
];

const PackageCarousel = ({ packageId, pageName, isReload, responsivePackage=[], isFromAppointmentDetails=false, packageName='', referrerPage, packageCategory, packageCategoryName }) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const dispatch = useDispatch();
  const t = useTranslation();
  const inViewRef = useRef();
  const [eventFired, setEventFired] = useState(false);
  const [homePackages, setHomePackages] = useState([]);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);

  const serializeResponse = (packageList, amoutResponse) => {
    const finalPackageList = packageList?.map((packages) => {
      const packageAmount = amoutResponse.find((amounts) => amounts?.packageId === packages?.id);
      return {
        packageId: packages?.id,
        name: packages?.packageName,
        imageWeb: packages?.clinicPackageImages?.imageWeb?.url,
        packageContentSize: packages?.servicesListed?.length,
        netPrice: packageAmount && packageAmount?.amount,
        SavedAmount: packages?.amountSaved,
        isMyAsterExclusive: packageAmount?.isMyAsterExclusive,
        packageExpiryDate: packageAmount && packageAmount?.packageExpiryDate,
        speciality: packages?.speciality,
        isHomeSampleCollectionAllowed: packageAmount?.isHomeSampleCollectionAllowed,
      };
    });
    setHomePackages(finalPackageList);
  };

  const getAmountForPackages = (packageResponse, ids) => {
    if (ids) {
      dispatch(
        getPackageAmountList({
          requestParam: {
            PackageIds: ids,
          },
          onSuccess: (response) => {
            if (response?.data?.length > 0) {
              serializeResponse(packageResponse, response?.data);
            }
          },
          onFailure: () => {},
        }),
      );
    }
  };

  useEffect(() => {
    if (packageId && (guestLogin || userLogin)) {
      dispatch(
        getCmsPackageList({
          requestParam: {
            id: packageId,
          },
          onSuccess: (response) => {
            if (response?.data?.data?.length > 0) {
              getAmountForPackages(response?.data?.data, packageId);
            }
          },
          onFailure: () => {},
        }),
      );
    }
  }, [packageId, isReload]);

  const getOuterCustomClass =() =>{
    if(pageName === 'Aster Core Home'){
      return 'newPackageSection';
    }else if(pageName === 'appointmentdetails' || pageName === 'bookingConfirmation'){
      return 'packageCarouselSection';
    }else if(pageName=== 'packagedetails'){
      return 'newPackageDetail';
    }else{
      return ''
    }
  }

  const getTitle = () => {
    if (pageName === 'Aster Core Home' || pageName === "Tele Consult Home" ||pageName === 'appointmentdetails' || pageName === 'bookingConfirmation') {
      return 'Health Packages curated for you';
    } else if (pageName === 'packagedetails') {
      return 'Related Health Packages';
    } else {
      return '';
    }
  };

  const getShowViewAllCTA = ()=>{
    if(pageName === 'appointmentdetails'){
      if(homePackages?.length > 3){
        return true;
      }
    }else{
      if(homePackages?.length > 5){
        return true
      }
    }
    return false;
  };

  const getPageType = () => {
    if (pageName === 'Aster Core Home' || pageName === 'Tele Consult Home') {
      return PAGE_NAME?.ASCO;
    } else if (pageName === 'appointmentdetails') {
      return PAGE_NAME?.AP;
    } else if (pageName === 'bookingConfirmation') {
      return PAGE_NAME?.CP;
    } else if (pageName === 'packagedetails') {
      return PAGE_NAME?.PDP;
    }
  };

  const getScreenName = () => {
    if (pageName === 'Aster Core Home') {
      return PAGE_NAME?.HOME;
    } else if (pageName === 'Tele Consult Home') {
      return PAGE_NAME?.TC_HOME;
    } else if (pageName === 'appointmentdetails') {
      return PAGE_NAME?.ADP;
    } else if (pageName === 'bookingConfirmation') {
      return PAGE_NAME?.BCP;
    } else if (pageName === 'packagedetails') {
      return packageName?.toLowerCase();
    }
  };

  const handleInView = () => {
    if (!eventFired) {
      if (homePackages?.length > 0) {
        packageViewitemListEvent(homePackages, getTitle(), getPageType(), getScreenName(), referrerPage);
      }
      setEventFired(true);
    }
  };

  const viewItemListEvent = handleInView;

  const getSlideRange = (name) => {
    let range = 0;
    switch (name) {
      case 'appointmentdetails':
      case 'bookingConfirmation':
        range = 3.2;
        break;
      case 'packagedetails':
        range = 5.1;
        break;
      default:
        range = 5.1;
    }
    return range;
  };
  
  const ViewItemListAnalytics = withAnalytics(
    () => (
      <PackageCarouselStyled ref={inViewRef}>
        {homePackages?.length > 0 && (
          <SectionBox
            customOuterClass={`${getOuterCustomClass()} whiteBg`}
            role="button"
            title={getTitle()}
            rightTop={
              getShowViewAllCTA() && (
                <a
                  className="link cursor-pointer"
                  onClick={() => {
                    sendViewAllLinkEvent(getScreenName(), getPageType(), referrerPage, getTitle());
                    router.push({
                      pathname: generateURL(`${TELECONSULT_ROUTE}/${PACKAGE_URL}`),
                      query:
                        packageCategoryName
                          ? { category: packageCategory, name: packageCategoryName, referrerPage: pageName }
                          : { type: 'packages', referrerPage: pageName },
                    });
                  }}
                >
                  {t('EPharmacyHome.viewAll')}
                </a>
              )
            }
          >
            <SlickSlider
              sliderSettings={{
                responsive:
                  pageName === 'appointmentdetails' ||
                  pageName === 'bookingConfirmation' ||
                  pageName === 'packagedetails'
                    ? responsivePackage
                    : responsive,
                slidesToShow: getSlideRange(),
                infinite: false,
                className: 'packageCarousel',
                dots: false,
              }}
            >
              {homePackages?.map((packages) => (
                <Package
                  key={packages?.id}
                  packageId={packages?.packageId}
                  packageName={packages?.name}
                  packageImage={packages?.imageWeb}
                  packageExpiryDate={packages?.packageExpiryDate}
                  totalServices={packages?.packageContentSize}
                  actulaPrice={packages?.netPrice}
                  savedPrice={packages?.SavedAmount}
                  isMyAsterExclusive={packages?.isMyAsterExclusive}
                  screenName={pageName}
                  isFromFacility={false}
                  facilityName=""
                  facilityId=""
                  packages={packages}
                  pageName={pageName}
                  headerPackageName={packageName}
                  sectionName={getTitle()}
                  referrerPage={referrerPage}
                  packageCategory={packageCategory}
                  packageCategoryName={packageCategoryName}
                />
              ))}
            </SlickSlider>
          </SectionBox>
        )}
      </PackageCarouselStyled>
    ),
    viewItemListEvent,
    inViewRef,
  );

  return <>{homePackages?.length > 0 && <ViewItemListAnalytics />}</>;
};

PackageCarousel.propTypes = {
  pageName: PropTypes.string,
  packageId: PropTypes.string,
  isReload: PropTypes.bool,
  packageName: PropTypes.string,
  referrerPage: PropTypes.string,
  packageCategory: PropTypes.string,
  packageCategoryName: PropTypes.string,
};

PackageCarousel.defaultProps = {
  pageName: '',
  packageId: '',
  isReload: true,
  packageName: '',
  referrerPage: '',
};

export default PackageCarousel;
